<template>
  <v-dialog
    :value="enableDialog"
    persistent
    :width="showRecyclingFields ? 1800 : 1300"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer
      ref="bulkDisposalReportValidator"
    >
      <v-card flat>
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>
            {{ showRecyclingFields ? '処分終了報告（一括登録）再資源' : '処分終了報告（一括登録）' }}
            <!-- <template v-if="showRecyclingFields">
              <span class="orange--text ml-10" style="font-size: 70%">●</span>&nbsp;<span style="font-size: 70%">変更済</span>
            </template> -->
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text
          v-if="manifest"
          flat
          style="max-height: 60vh;overflow-y: scroll"
        >
          <v-row>

            <!-- 基本情報 -->
            <v-col
              cols="12"
              :md="showRecyclingFields ? 5 : 7"
            >
              <disposal-basic
                :manifest.sync="manifest"
                :quantity-units="quantityUnits"
                :users="users"
                callerType="bulk"
              />
            </v-col>
            <!-- /基本情報 -->

            <!-- 数量情報 -->
            <v-col
              cols="12"
              :md="showRecyclingFields ? 2 : 5"
            >
              <disposal-quantity
                :manifest.sync="manifest"
                :quantity-units="quantityUnits"
                :drivers="drivers"
                :vehicles="vehicles"
                callerType="bulk"
              />
            </v-col>
            <!-- /数量情報 -->

            <!-- 処分場処理情報等（再資源モード時のみ表示） -->
            <v-col
              v-if="showRecyclingFields"
              cols="12"
              :md="5"
            >
              <disposal-recycling
                :manifest.sync="manifest"
                :quantity-units="quantityUnits"
                caller-type="bulk"
                :is-matched="isAllManifestsMatched"
                :bulk-condition="bulkRecycleCondition"
              />
            </v-col>
            <!-- /処分場処理情報等 -->

          </v-row>

        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            class="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
    <Confirm ref="confirm" />
    <data-table-modal
      :descriptions="['自動連携されないマニフェストがあります。', '対象の１次マニフェストは手動で最終処分終了報告を登録してください。']"
      :enable="enablePrimaryManifestModal"
      :headers="primaryManifestHeaders"
      :items="primaryManifestResult"
      positive
      positive-caption="継続して登録"
      @close="dialogCloseCallback"
      @positiveCallback="dialogRegisterCallback"
    />
    <data-table-modal
      :enable="enableFirstManifestRecycleModal"
      :headers="firstManifestRecycleTableHeader"
      :items="firstManifestRecycleResult"
      :descriptions="['紐付く1次マニフェストの中間処分報告が再資源設定されている為、登録出来ません。']"
      @close="dialogCloseCallback"
    />
  </v-dialog>
</template>

<script>

import { mapActions } from 'vuex'
import DisposalBasic from './contents/_DisposalBasic.vue'
import DisposalQuantity from './contents/_DisposalQuantity.vue'
import DisposalRecycling from './contents/_DisposalRecycling.vue'
import Confirm from '@/components/Confirm.vue'
import DataTableModal from "@/driver/pages/dialogs/_DataTableModal.vue";

export default {
  name: 'BulkDisposalReportDialog',
  components: {
    DataTableModal,
    DisposalBasic,
    DisposalQuantity,
    DisposalRecycling,
    Confirm,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    manifestIds: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: () => null,
    },
    orderIds: {
      type: Array,
      default: () => [],
    },
    showRecyclingFields: {
      type: Boolean,
      default: () => false,
    },
    /**
     * マニフェスト(1次, 2次)
     */
    manifestLevel: {
      type: String,
      default: "first_manifest"
    },
  },
  data() {
    return {
      manifest: null,
      selectedManifests: [],
      users: [],
      drivers: [],
      vehicles: [],
      quantityUnits: [],

      enablePrimaryManifestModal: false,
      primaryManifestHeaders: [
        { value: 'second_manifest_no', text: '2次マニフェスト番号' },
        { value: 'second_manifest_id', text: 'DXEマニ番号' },
        { value: 'primary_manifest_no', text: '1次マニフェスト番号' },
        { value: 'primary_manifest_id', text: 'DXEマニ番号' },
        { value: 'primary_manifest_type_name', text: 'マニフェスト区分' },
        { value: 'primary_manifest_collected_date', text: '引渡日' },
      ],
      primaryManifestResult: [],

      enableFirstManifestRecycleModal: false,
      firstManifestRecycleTableHeader: [
        { value: "manifest_no",
          text: "2次マニフェスト番号",
          width: "50%"
        },
        { value: "id",
          text: "DXEマニ番号",
          width: "50%"
        },
      ],
      firstManifestRecycleResult: []
    }
  },
  computed: {
    /**
     * 選択された全マニフェストで、処分事業者（disposer_id）・処分事業場（disposer_location_code）・
     * 品目（item_id + item_type）がすべて一致しているかを判定する。
     * 0件・1件のときは比較相手が無いため一致（true）とみなす。
     * @return {boolean} 全件一致なら true / 1件でも異なれば false
     */
    isAllManifestsMatched () {
      if (this.selectedManifests.length <= 1) {
        return true
      }
      const base = this.selectedManifests[0]
      return this.selectedManifests.every((manifest) => {
        return manifest.disposer_id === base.disposer_id &&
          manifest.disposer_location_code === base.disposer_location_code &&
          manifest.item_id === base.item_id &&
          manifest.item_type === base.item_type
      })
    },
    /**
     * 一括（再資源）で処分場処理方法の候補取得に渡す3キー。
     * 全件一致のときのみ selectedManifests[0] から共通値（item_id / disposer_id /
     * disposer_location_id / disposer_location_code）を返す。候補取得 API に渡すのは個別（再資源）モードと同じ3キーで、
     * item_type は判定（isAllManifestsMatched）には使うが候補取得には渡さない。
     * 不一致、または selectedManifests が未取得（空）のときは null を返し、
     * 子側（_DisposalRecycling.vue）で候補取得を行わせない（候補を空にする）。
     * @return {{item_id: *, disposer_id: *, disposer_location_id: *, disposer_location_code: *}|null}
     */
    bulkRecycleCondition () {
      // isAllManifestsMatched は0件・1件を true 扱いにするため、0件ガードを併用する
      // （0件で selectedManifests[0] を読むと undefined 参照になるのを防ぐ）
      if (!this.isAllManifestsMatched || this.selectedManifests.length === 0) {
        return null
      }
      const base = this.selectedManifests[0]
      return {
        item_id: base.item_id,
        disposer_id: base.disposer_id,
        disposer_location_id: base.disposer_location_id,
        disposer_location_code: base.disposer_location_code,
      }
    },
  },
  watch: {
    enableDialog (newValue) {
      this.manifest = null
      this.$nextTick(() => this.$refs.bulkDisposalReportValidator.reset())
      if (newValue) {
        this.setVariable()
      }
    },
    /*
     * 報告区分の変更を監視する。
     * 再資源モードで「最終」に切り替えたとき、同一チェック不一致なら確認モーダルを出して中間に戻す。
     * @param {string} newValue 変更後の報告区分（'middle_report' / 'last_report'）
     */
    'manifest.disposal_report_type' (newValue) {
      // 「最終」以外（中間化・初期化）への変化では何もしない
      // （中間に戻す再代入で watch が再発火しても、ここで止まり確認モーダルが二度出るのを防ぐ）
      if (newValue !== 'last_report') {
        return
      }
      // 再資源モードかつ同一チェック不一致のときだけ、最終を不可とする
      if (this.showRecyclingFields && !this.isAllManifestsMatched) {
        this.confirmFinalReportNotAllowed()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverManifestDisposalReport', {
      fetchNew: 'new',
      fetchDisposalReports: 'show',
      bulkRegister: 'create',
    }),
    ...mapActions('DriverOrderDisposalReport', {
      fetchNewByOrder: 'new',
      bulkRegisterByOrder: 'create',
    }),
    ...mapActions('DriverMasterSearchUser', {
      fetchUsers: 'index',
    }),
    ...mapActions('DriverMasterSearchDriver', {
      fetchDrivers: 'only_text',
    }),
    ...mapActions('DriverMasterSearchVehicle', {
      fetchVehicles: 'search'
    }),
    ...mapActions('DriverMasterSearchQuantityUnit', {
      fetchQuantityUnits: 'index',
    }),
    /**
     * 紐付く1次マニの自動連携チェック処理
     */
    ...mapActions("DriverManifestPrimaryManifestSyncCheck", {
      cheCheck: "create"
    }),
    ...mapActions("DriverManifestFirstManifestIncludedRecycleCheck", {
      firstManifestIncludedRecycleCheck: "create"
    }),

    /**
     *
     */
    closeButtonClickEvent () {
      this.$emit('cancelCallback')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      const $self = this
      this.$refs.bulkDisposalReportValidator.validate().then((result) => {
        if (result) {
          if (this.manifestLevel === 'first_manifest') {
            setTimeout($self.registerInformation, 500);
          } else if (this.manifestLevel === 'second_manifest') {
            // if (this.showRecyclingFields) {
              // 再資源
              // this.checkAndRegisterSecondManifest();
            // } else {
              // 通常
              this.firstManifestIncludedRecycleCheckAndRegisterSecondManifest()
            // }
          }
        }
      })
    },

    /**
     * 登録リクエストの送信
     */
    registerInformation () {
      let params = this.buildParams()

      if (this.type === "Managements") {
        this.bulkRegister({params: params}).then(() => {
          this.$emit('registerEvent')
        })
      } else {
        params['order_ids'] = this.orderIds
        this.bulkRegisterByOrder({params: params}).then(() => {
          this.$emit('registerEvent')
        })
      }

    },

    firstManifestIncludedRecycleCheckAndRegisterSecondManifest () {
      this.firstManifestRecycleResult = [];
      if (this.manifest.disposal_report_type === 'last_report' && (this.manifest.after_disposal_details === undefined || this.manifest.after_disposal_details.length <= 0)) {
        // 最終
        const params = { manifest_ids: this.manifestIds }
        this.firstManifestIncludedRecycleCheck({ params: params }).then((data) => {
          const result = data.result
          const content = data.content;
          if (result.code === 'ok') {
            this.checkAndRegisterSecondManifest()
          } else {
            this.firstManifestRecycleResult = content.invalid_manifests;
            this.enableFirstManifestRecycleModal = true;
          }
        })

      } else {
        // 中間
        this.checkAndRegisterSecondManifest()
      }
    },

    /**
     * 2次マニ
     * 登録前の1次マニへの自動連携チェック処理
     */
    checkAndRegisterSecondManifest () {
      const $self = this;

      if (this.manifest.disposal_report_type === 'last_report' && (this.manifest.after_disposal_details && this.manifest.after_disposal_details.length > 0)) {
        this.cheCheck({ params: { manifest_ids: this.manifestIds }}).then((response) => {
          const result = response.result;
          const content = response.content;
          if (result.code === 'ok') {
            console.log('checkAndRegisterSecondManifest ok');
            setTimeout($self.registerInformation, 500);
          } else {
            this.primaryManifestResult = content.unsync_primary_manifests
            this.enablePrimaryManifestModal = true;
          }
        })

      } else {
        console.log('checkAndRegisterSecondManifest 以外');
        setTimeout($self.registerInformation, 500);
      }


    },
    /**
     * 連携対象外マニフェストのダイアログ 閉じるボタンコールバック
     */
    dialogCloseCallback() {
      this.enablePrimaryManifestModal = false;
      this.enableFirstManifestRecycleModal = false;
    },
    /**
     * 連携対象外マニフェストのダイアログ 実行ボタンコールバック
     */
    dialogRegisterCallback() {
      this.dialogCloseCallback();
      const $self = this;
      setTimeout($self.registerInformation, 500);
    },
    /**
     * リクエスト情報の生成
     * @return {{manifest: {}, manifest_ids: *[], type: string}}
     */
    buildParams () {
      let param = {}
      param.disposal_report_type = this.manifest.disposal_report_type
      param.disposal_report_person = this.manifest.disposal_report_person
      param.disposal_report_end_date = this.manifest.disposal_report_end_date
      param.disposal_report_reporter = this.manifest.disposal_report_reporter
      param.disposal_report_driver = this.manifest.disposal_report_driver
      if (this.manifest.disposal_report_vehicle_number === null) {
        param.disposal_report_vehicle_number = ''
      } else if (typeof this.manifest.disposal_report_vehicle_number === "object") {
        param.disposal_report_vehicle_number = this.manifest.disposal_report_vehicle_number.number
      } else {
        param.disposal_report_vehicle_number = this.manifest.disposal_report_vehicle_number
      }
      param.disposal_report_receipt_date = this.manifest.disposal_report_receipt_date
      param.disposal_report_amount = this.manifest.disposal_report_amount
      param.disposal_report_amount_unit_id = this.manifest.disposal_report_amount_unit_id
      param.disposal_report_remarks = this.manifest.disposal_report_remarks
      param.disposal_standard_quantity_type = this.manifest.disposal_standard_quantity_type
      param.recycle_disposer_disposal_method_id = this.manifest.recycle_disposer_disposal_method_id

      // 再資源化処分場処理方法詳細（recycle_disposer_disposal_method_details）の行の配列。
      // 未選択時は undefined になるため、空配列 [] で代替してから map する（undefined.map の TypeError 回避）。
      const afterDisposalDetails = Array.isArray(this.manifest.after_disposal_details)
        ? this.manifest.after_disposal_details
        : []

      param.after_disposal_details = afterDisposalDetails.map((detail) => {
        return {
          recycle_disposer_disposal_method_detail_id: detail.id || null,
          // 0%（数値0）も正当な入力のため ?? を使う（|| だと 0 が null に化ける）。
          before_disposal_ratio: detail.before_disposal_ratio_input ?? null,
          comment: detail.comment_input || null,
          after_disposal_ratio: detail.after_disposal_ratio_input ?? null,
          final_disposal: detail.final_disposal || false,
        }
      })

      return {
        manifest: param,
        manifest_ids: this.manifestIds,
        type: this.type,
      }
    },
    /**
     * 初期値の設定
     */
    setVariable () {
      this.fetchDrivers({without_invisible: true}).then((content) => { this.drivers = content })
      this.fetchQuantityUnits().then((content) => { this.quantityUnits = content.quantity_units })
      this.fetchUsers({without_invisible: true}).then((content) => { this.users = content.users })
      this.fetchVehicles({registered_number: ''}).then((content) => { this.vehicles = content.vehicles })
      // 同一チェック用の比較キー（disposer_id / disposer_location_code / item_id / item_type）を取得
      this.fetchDisposalReports({ params: { manifest_ids: this.manifestIds } }).then((content) => {
        this.selectedManifests = content.manifests
      })
      if (this.type === "Managements") {
        this.fetchNew().then((content) => {
          this.manifest = content
          this.manifest.target_for_registration = true
        })
      } else {
        this.fetchNewByOrder().then((content) => {
          this.manifest = content
          this.manifest.target_for_registration = true
        })
      }
    },
    /**
     * 報告区分=最終が選べない旨の確認モーダルを表示し、閉じたら報告区分を中間に戻す。
     * 呼び出し条件（再資源モード・最終・同一チェック不一致）は watch 側で判定済み。
     */
    confirmFinalReportNotAllowed () {
      this.$refs.confirm.open({
        title: '確認',
        message: '処分事業者・処分事業場・品目が一致していない為、報告区分を最終に出来ません。',
        options: { titleColor: 'red', isCancelButton: false, successTitle: '閉じる', width: 500 }
      }).then(() => {
        // 「閉じる」押下で報告区分を中間に戻す（この再代入は watch で newValue!=='last_report' のため何もしない）
        this.manifest.disposal_report_type = 'middle_report'
      })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
